import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISimTypeModel } from '@apps-common/types/management/sim-type'

export const updateSimType = async (model: ISimTypeModel): Promise<ISimTypeModel> =>
  axios.post(`/management/simtype/updatesimtype`, model).then((res) => res?.data?.data)

type Props = {
  model: ISimTypeModel
}

export const useManagementUpdateSimType = (notify?: boolean, onSuccess?: (data: ISimTypeModel) => void) =>
  useMutation({
    mutationKey: ['updateSimType'],
    mutationFn: ({ model }: Props) => updateSimType(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated sim type.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update sim type, please try again.')
      }
    },
    throwOnError: false
  })
